module.exports = __webpack_public_path__ + "media/assets/icons/NPS-5a747f186cd8fd16d55ce9a2ab57fcf4.svg";